import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faUsers } from "@fortawesome/free-solid-svg-icons";

const ResultadoImportacao = ({
  tipoImportacao = "",
  totalImportados,
  totalSucesso,
  totalErro,
}) => {
  return (
    <div className="row">
      <div className="col-12">
        <div className="font-weight-bold mb-3">
          <i className="text-orange">
            {" "}
            <FontAwesomeIcon icon={faUsers} />{" "}
          </i>{" "}
          Total {tipoImportacao ? " de " + tipoImportacao : ""}:
          <span className="font-weight-normal">{" " + totalImportados}</span>
        </div>
        <div className="font-weight-bold mb-3">
          <i className="text-success">
            <FontAwesomeIcon icon={faUsers} />
          </i>{" "}
          Total {tipoImportacao ? " de " + tipoImportacao : ""} com Sucesso:{" "}
          <span className="font-weight-normal"> {" " + totalSucesso}</span>
        </div>
        <div className="font-weight-bold mb-3">
          <i className="text-danger">
            <FontAwesomeIcon icon={faUsers} />
          </i>{" "}
          Total {tipoImportacao ? " de " + tipoImportacao : ""} com Erro:{" "}
          <span className="font-weight-normal"> {" " + totalErro}</span>
        </div>
      </div>
    </div>
  );
};

export default ResultadoImportacao;
